var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('goods-tag-cell',{ref:"goodsTagCell",attrs:{"row":_vm.row,"auth":"team-sea:tags:set-anchor-tags","editTag":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }